"use strict";

require("../../style/index.less");

require("./index.less");
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/lib/tooltip/style/index.js
// module id = 1507
// module chunks = 0